export const REPORT_MIN_MATCHES = 10;

export const isReportUnlocked = (matchCount) => {
  const n = Number(matchCount);
  return Number.isFinite(n) && n >= REPORT_MIN_MATCHES;
};

export const matchesUntilUnlock = (matchCount) => {
  const n = Number(matchCount);
  const safe = Number.isFinite(n) ? n : 0;
  return Math.max(REPORT_MIN_MATCHES - safe, 0);
};
